import { Link } from "react-router-dom";
import { PrimaryBtn } from "@/components/site/shared";

export default function NotFound() {
  return (
    <section className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center">
        <p className="font-head font-extrabold text-7xl text-[var(--navy)]">404</p>
        <h1 className="font-head font-bold text-2xl text-[var(--navy)] uppercase mt-2">Page Not Found</h1>
        <p className="text-[var(--text-muted)] mt-2">The page you're looking for doesn't exist.</p>
        <div className="mt-6"><PrimaryBtn to="/">Back to Home</PrimaryBtn></div>
      </div>
    </section>
  );
}
